<div class="input-number">
    <label class="col-form-label" v-if="label" :for="id">{{ label }} <span v-if="required">(*)</span></label>
    <input class="form-control" :class="{ 'is-error': isError }" v-model="value" type="number" :id="id"
           :disabled="disabled" @blur="onBlur" :placeholder="placeholder"
            maxlength="19"
           onkeydown="if(['e','E','+','-'].includes(event.key)) event.preventDefault();"
    />
    <div class="error-text" v-if="errorText">{{errorText}}</div>
</div>
